import { BodyCreateWithAssign, BodyUpdateWithAssign } from "src/entity/map-company-user/map-company-user";
import http from "../utils/http-common";
import { GetUserManagementFilter } from "src/entity/user-management/users-state.entity";

export const getMyAssignCompany = (userId: string) => {
  return http.get(`/api/map-company-user/me/${userId}`);
};
export const getUserInCompany = (companyId: string) => {
  return http.get(`/api/map-company-user/users/company/${companyId}`);
};

export const getUserManagement = (filter: GetUserManagementFilter) => {
  return http.post(`/api/map-company-user/users/filter`, filter);
};
export const getAllCompanyRoleByUserId = (userId: string) => {
  return http.get(`/api/map-company-user/company-role/user-id/${userId}`);
};

export const getAllRoles = () => {
  return http.get(`/api/role`);
};
export const getAllCompany = () => {
  return http.get(`/api/company`);
};

export const createAndAssign = (data: BodyCreateWithAssign) => {
  return http.post(`/api/users/create-and-assign`, data);
};
export const updateAssignRoles = (data: BodyUpdateWithAssign) => {
  return http.put(`/api/users/update-assign-role`, data);
};
export const deleteUser = (userId: string) => {
  return http.delete(`/api/users/delete/${userId}`);
};
export const getCompanyIamCompanyAdmin = () => {
  return http.get(`/api/map-company-user/iam/company-admin`);
};
export const checkCanProcessApproval = () => {
  return http.get(`/api/map-company-user/check-approval`);
};

export const AuthenService = {
  getMyAssignCompany,
  getUserInCompany,
  getAllRoles,
  updateAssignRoles,
  deleteUser,
  getUserManagement,
  getAllCompanyRoleByUserId,
  getCompanyIamCompanyAdmin,
};
